import React from "react";
import "./comp_digital_transaction.css";


export const Comp_Digital_Trans_ForPurchase=({transactions=[]})=>{

  
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        return d.toLocaleString("en-IN");
      };

  return (
    <div className="txn-container">
      {transactions.map((txn, index) => (
        <div key={index} className="card mb-3 shadow-sm p-3">
          
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <span className={`badge ${txn.trans_type === "Add" ? "bg-success" : "bg-danger"}`}>
              {txn.trans_type}
            </span>
            <span className="ms-2 fw-bold">₹ {txn.balance}</span>
          </div>

          <div className="text-end">
            <div className="small text-muted">
            <span className={`badge ${txn.status === "Approved" ? "bg-success" : "bg-danger"}`}>
              {txn.status}
            </span>
             
            </div>
          </div>
        </div>

        {/* New Row for Extra Info */}
        <div className="mt-2 d-flex justify-content-between flex-wrap">
          
          <div className="small text-muted">
            <strong>Date:</strong> {formatDate(txn.payment_date)}
          </div>

          <div className="small text-muted">
            <strong>Request ID:</strong> {txn.id}
          </div>

        </div>

        <div className="mt-1 small">
          <strong>Note:</strong> {txn.category_name}
        </div>

      </div>
      ))}
    </div>
  );
}


export const Comp_Digital_Transaction = ({ transactions = [] }) => {

  
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        return d.toLocaleString("en-IN");
      };

  return (
    <div className="txn-container">
      {transactions.map((txn, index) => (
        <div key={index} className="card mb-3 shadow-sm p-3">
          
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <span className={`badge ${txn.trans_type === "Add" ? "bg-success" : "bg-danger"}`}>
              {txn.trans_type}
            </span>
            <span className="ms-2 fw-bold">₹ {txn.balance}</span>
          </div>

          <div className="text-end">
            <div className="small text-muted">
              Available Balance ₹ {txn.running_balance}
            </div>
          </div>
        </div>

        {/* New Row for Extra Info */}
        <div className="mt-2 d-flex justify-content-between flex-wrap">
          
          <div className="small text-muted">
            <strong>Date:</strong> {formatDate(txn.payment_date)}
          </div>

          <div className="small text-muted">
            <strong>Request ID:</strong> {txn.id}
          </div>

        </div>

        <div className="mt-1 small">
          <strong>Note:</strong> {txn.category_name}
        </div>

      </div>
      ))}
    </div>
  );
};

export default Comp_Digital_Transaction;